// Uber Freight load ids are matched as-is in the portal loads table
// (for example UF-123). Do not strip to a numeric core — that would drop
// letter prefixes the row search needs.
export function normalizeUberFreightLoadId(raw: string): string {
  return raw.trim();
}
